import { colorize, is } from '@wp-g2/utils';
import { css } from '../style-system';
import { toPx } from './units';
/**
 * @param {number} value
 * @return {string}
 */

export function getBoxShadow(value) {
  var boxShadow = "0 " + toPx(value) + " " + toPx(value * 2) + " 0\n\t" + ("rgba(0 ,0, 0, " + value / 20 + ")");
  return boxShadow;
}
/**
 * @param {number | { color: string, radius: number, x: number, y: number }} value
 * @return {string}
 */

export function getShadow(value) {
  if (typeof value === 'number') {
    return css({
      boxShadow: getBoxShadow(value)
    });
  }

  if (!is.plainObject(value)) {
    return '';
  }

  var _value$color = value.color,
      color = _value$color === void 0 ? 'black' : _value$color,
      _value$radius = value.radius,
      radius = _value$radius === void 0 ? 10 : _value$radius,
      _value$x = value.x,
      x = _value$x === void 0 ? 0 : _value$x,
      _value$y = value.y,
      y = _value$y === void 0 ? 5 : _value$y;
  var shadowColor = colorize(color).setAlpha(0.3).toRgbString() || 'rgba(0, 0, 0, 0.3)';
  return css({
    boxShadow: toPx(x) + " " + toPx(y) + " " + toPx(radius) + " " + shadowColor
  });
}